<template>
    <router-view></router-view>
</template>
<script>
    export default {}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/stock/index.vue